export const PROFILE_DESCRIPTIONS = {
    "The Disciplined Driver": {
      dominantTraits: ["Reliability", "Competitiveness", "Accountability"],
      summary: "Goal-oriented, consistent, and results-driven. These athletes thrive in structured, high-expectation environments and excel under measurable performance targets.",
      coachingStyle: "Provide clear goals, reinforce accountability, and maintain a results-focused environment.",
      challenges: "May be overly rigid or critical in emotionally complex situations.",
      idealEnvironment: "Systems with performance benchmarks and leadership demands.",
    },
    "The Adaptive Learner": {
      dominantTraits: ["Coachability", "Resiliency", "Poise"],
      summary: "Responsive to feedback, emotionally composed, and quick to recover from setbacks. Highly trainable and adaptive in dynamic situations.",
      coachingStyle: "Use structured feedback, challenge their growth mindset, and give space to adapt and iterate.",
      challenges: "May lack natural competitiveness or struggle to assert themselves in high-stakes moments.",
      idealEnvironment: "Development-focused programs with evolving roles.",
    },
    "The Steady Supporter": {
      dominantTraits: ["Teamwork", "Agreeableness", "Reliability"],
      summary: "Loyal, consistent, and collaborative. Often the unsung heroes who elevate overall team chemistry and dependability.",
      coachingStyle: "Emphasize clarity, consistency, and values-driven engagement.",
      challenges: "May resist assertive leadership roles or underplay their own contributions.",
      idealEnvironment: "Team-centric systems with shared goals and a clear sense of purpose.",
    },
    "The Assertive Competitor": {
      dominantTraits: ["Competitiveness", "Confidence", "Leadership"],
      summary: "Bold, vocal, and performance-focused. Thrives under challenge and seeks to lead by example in competitive arenas.",
      coachingStyle: "Set ambitious benchmarks, emphasize individual excellence, and allow autonomy.",
      challenges: "Can create friction if team dynamics or emotional cues are ignored.",
      idealEnvironment: "High-stakes, performance-driven teams with visible leadership opportunities.",
    },
    "The Quiet Craftsman": {
      dominantTraits: ["Reliability", "Poise"],
      summary: "Precise, dependable, and emotionally steady. Prefers low-drama environments and quietly excels in defined roles.",
      coachingStyle: "Use structure, clarity, and consistent routines.",
      challenges: "May avoid visibility or leadership responsibility.",
      idealEnvironment: "Tactical roles with minimal ambiguity and clear expectations.",
    },
    "The Coach's Mirror": {
      dominantTraits: ["Coachability", "Accountability", "Agreeableness"],
      summary: "Introspective, humble, and responsive to feedback. Often trusted by coaches and peers alike.",
      coachingStyle: "Provide mentorship, reinforce accountability, and nurture self-led development.",
      challenges: "May defer too much or under-assert in competitive settings.",
      idealEnvironment: "Growth-oriented environments with feedback-driven development paths.",
    },
    "The Resilient Maverick": {
      dominantTraits: ["Resiliency", "Confidence"],
      summary: "Self-motivated, pressure-tested, and autonomous. Excels in chaos and often bounces back stronger from setbacks.",
      coachingStyle: "Respect autonomy, challenge them with meaningful goals, and avoid micromanagement.",
      challenges: "Can appear resistant to feedback or detached from team flow.",
      idealEnvironment: "Competitive scenarios that demand individual problem-solving and grit.",
    },
  };